/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';
import { IHealthDuplicateState, IHealthDuplicateTypes } from './types';

const INITIAL_STATE: IHealthDuplicateState = {
  data: null,
  loading: false,
  error: null,
};

const healthDuplicate: Reducer<IHealthDuplicateState> = (
  state = INITIAL_STATE,
  action,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IHealthDuplicateTypes.HEALTH_DUPLICATE_SET_DATA: {
        draft.data = action.payload.data;
        break;
      }
      case IHealthDuplicateTypes.HEALTH_DUPLICATE_REQUEST: {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case IHealthDuplicateTypes.HEALTH_DUPLICATE_SUCCESS: {
        draft.data = null;
        draft.loading = false;
        draft.error = null;
        break;
      }
      case IHealthDuplicateTypes.HEALTH_DUPLICATE_FAILURE: {
        draft.loading = false;
        draft.error = action.payload.error;
        break;
      }
      case IHealthDuplicateTypes.HEALTH_DUPLICATE_RESET: {
        draft.data = null;
        draft.loading = false;
        draft.error = null;
        break;
      }
      default:
        break;
    }
  });
};

export default healthDuplicate;
